import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, Input, OnInit, signal } from '@angular/core';
import { timeout, timer } from 'rxjs';
import { ConfigService } from 'src/app/config.service';

export type StaffPhotoSize = 'small' | 'medium' | 'large' | "xl";

@Component({
  selector: 'app-staff-photo',
  imports: [],
  templateUrl: './staff-photo.component.html',
  styleUrls: ['./staff-photo.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,

})
export class StaffPhotoComponent implements OnInit {





  staffId = input.required<number | null>()
  bustCache = input<boolean>(false)
  photoError = signal(false)
  ready = signal(false)

  staffPhotoUrl = computed(() => {

    const photoError = this.photoError()
    const staffId = this.staffId()
    const ready = this.ready()
    const bustCache = this.bustCache()

    if (!staffId || photoError) {
      //1x1 transparent
      return "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII="
    }

   
    return this.config.staffPhotoUrl + staffId + ".jpg" + (bustCache ? "?bustCache=" + Date.now() : "")

  })


  size = input<StaffPhotoSize>('small')

  imageSize = computed(() => {
    switch (this.size()) {
      case 'small':
        return "32"
      case 'medium':
        return "64"
      case 'large':
        return "128"
      case 'xl':
        return "256"
      default:
        return "32"
    }
  })

  rounded = input<boolean>(true)

  roundedClass = computed(() => {
    return this.rounded() ? "rounded-[50%]" : ""
  })



  constructor(
    private config: ConfigService
  ) {

    

   }

  ngOnInit(): void {
    timer(200).subscribe(() => {
      this.ready.set(true)
    })
  }

  onError(event: ErrorEvent) {

    this.photoError.set(true)
  }

}
